/**
 * Adzuki
 * segment_selection.js
 */

(function SegmentSelection($, Adzuki)
{
	"use strict";

	// selectors used for instantiating this must be unique.
	// unfortunately, there's no way to reliably get the selector used to create
	// a jQuery object, so i'm only tracking string-based selectors.
	var selectors = [];

	var segmentSelection = function SegmentSelection(el)
	{
		var $el,
		    $template,
		    $container,
		    $input_field,
		    type,
		    uri,
		    form_name       = 'segment',
		    _selected       = {},
		    _insert_on_blur = false;

		try
		{
			if (el instanceof jQuery) {
				$el = el;
			}
			else {
				if (selectors.indexOf(el) === -1) {
					selectors.push(el);
				}
				else {
					console.warn('[Adzuki.SegmentSelection] potential duplicate selector detected.');
				}

				$el = $(el);
			}

			$template    = $el.find(".segment.template");
			$container   = $el.find(".selected-segments");
			$input_field = $el.find('input[type="text"].search');
		}
		catch (err) {
			console.log('[Adzuki.SegmentSelection]', err);
		}

		if ($input_field.data("form-name")) {
			form_name = 'form_component_data[' + $input_field.data("form-name") + '][segment]';
		}

		Adzuki.Typeahead(
			$input_field,
			function search(term, display, $self)
			{
				_insert_on_blur = false;
				type            = $el.find(".type").val();
				uri             = '/Searches/segment/'+term;

				if ($self.data('no-email-required') !== undefined) {
					uri += '/0';
				}

				Adzuki.Ajax.get(uri)
				.then(function searchDisplay(response)
				{
					$self.removeClass('ajax-spinner');
					display(response);

					// in the case where an email address is not in our db,
					// we allow them to manually select it as a segment.
					// this tracks state so when people don't explicitly click
					// the "no results found, click to use x" we can do it automatically.
					if (response.length === 1) {
						if (response[0].status === 'insert_email') {
							_insert_on_blur = true;
						}
					}
				})
				.catch(function searchError()
				{
					$self.removeClass('ajax-spinner');
					display([{name: "Error searching for segments."}]);
				});
			},
			function select(item, $self, context)
			{
				var type,
				    label,
				    item_id;

				if (item.status) {
					if (item.status === 'insert_email') {
						type    = 'manual_email';
						item_id = item.email;
						label   = item.email;
					}
				}
				else if (item.id === undefined) {
					$self.val('');
					return;
				}
				else {
					type    = item.type.toLowerCase().replace(/\s/g, '-');
					item_id = item.id;
					label   = '<b>'+type.charAt(0).toUpperCase()+item.type.slice(1)+':</b> '+item.name;
				}

				if (_selected[type] === undefined) {
					_selected[type] = [];
				}

				_selected[type].push(item_id);

				// setTimeout(function clearsegmentsearch() {
					$self.val('');
				// }, 100);

				_insert_on_blur = false;
				addSegmentLabel(item_id, label, type);
			},
			function template(item) {
				var val = item.name;

				if (type === 'all' && typeof item.type !== 'undefined') {
					val = item.type.charAt(0).toUpperCase()+item.type.slice(1) + ' - '+val;
				}

				return val;
			},
			function matcher(item) {
				if ($.inArray(item.id, _selected[item.type]) > -1) {
					return false;
				}

				return true;
			}
		);

		$el.on('click', '.remove', function remove() {
			var $self = $(this),
			    $input,
			    type,
			    // extract the type from the input name
			    type_regex = form_name.replace(/([\[\]])/g, "\\$1")+"(?:\\]?)\\[([\\w\\-]+)\\]";

			// remove segment from internal tracking
			$input = $self.siblings('input');
			type   = $input.prop('name').match(type_regex)[1];

			if (_selected[type] !== undefined) {
				_selected[type].splice(_selected[type].indexOf($input.val()), 1);
			}

			$self.parents('.segment').remove();

			if ($el.find('.segment').length <= 2) {
				$container.addClass('hidden');
			}
		});

		$el.on('click', '.remove-all', function removeAll() {
			$(this).parents('.segments')
			     .find('.segment')
			     .not('#remove-all')
			     .not('.template')
			     .remove();

			_selected = {};

			if ($el.find('.segment').length <= 2) {
				$container.addClass('hidden');
			}
		});

		$el.on('blur', 'input[type="text"].search', function selectOnBlur() {
			var $self = $(this),
			    email = $self.val();

			setTimeout(function waitToSelectOnBlur() {
				if (_insert_on_blur) {
					addSegmentLabel(email, email, 'manual_email');
					$self.val('');
					_insert_on_blur = false;
				}
			}, 100);
		});

		function addSegmentLabel(id, label, type)
		{
			var $segment = $template.clone();
			$segment.removeClass('template');
			$segment.find('input').val(id).attr('name', form_name + '['+type+'][]');
			$segment.find('.title').html(label);
			$segment.appendTo($container.find('.segments'));

			if ($container.hasClass('hidden')) {
				$container.removeClass('hidden');
			}
		}
	};

	Adzuki.SegmentSelection = segmentSelection;
}(jQuery, window.Adzuki || {}));
